// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__GaZIN","messages":"Chat_messages__31UZ9","dateDivider":"Chat_dateDivider__336m0"};